import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { PayoutResultAll } from "types/enums";

interface UsePayoutResultSelectOptionsParams {
    /** Include empty option at the beginning */
    withEmptyOption?: boolean;
}

export const usePayoutResultSelectOptions = (params: UsePayoutResultSelectOptionsParams = {}) => {
    const { withEmptyOption = false } = params;
    const { t } = usePaldockTranslation("general.payout_result");

    const enumOptions = Object.entries(PayoutResultAll).map(([key, value]) => ({
        label: t(key.toLowerCase()),
        value: value,
    }));

    const options = withEmptyOption
        ? [{ label: "", value: "" }, ...enumOptions]
        : enumOptions;

    return { options, loading: false, error: null };
};
